import React, { useState, useEffect } from 'react';
import './quote-detail.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import Popup from '../popup/Popup';
import '../popup/popup.scss';
import { addInterestToPrice } from '../../functions/Renewal';

export default function RenewalQuoteDetail(props: any) {

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const config = JSON.parse(localStorage.getItem('siteConfig') || "{}");

    function disableScrolling() {
        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function () { window.scrollTo(x, y); };
    }

    function enableScrolling() {
        window.onscroll = function () { };
    }

    const togglePopup = () => {
        if (!isPopupOpen) {
            disableScrolling();
        } else {
            enableScrolling();
        }

        setIsPopupOpen(!isPopupOpen);
    }

    const documentExists = (path: any) => {
        try {
            require(`../../${path}`);
            return true;
        } catch (err) {
            return false;
        }
    };

    return (
        <div className="quote-detail">
            <p className="reference-number">Reference number: {props.policyNumber}</p>
            <p className="detail-header">Sums insured</p>
            {props.quote.breakdown.cover.map((premCover: any, index: number) => {

                return (<div key={"sums_" + index} className="quote-detail-row">
                    <span>{premCover.coverText}</span>
                    <span className="detail-value">{premCover.coverValue}</span>
                </div>)
            })}

            <p className="detail-header">Excess</p>

            {props.quote.breakdown.excesses != null && props.quote.breakdown.excesses.map((excess: any, index: number) => {

                return (<div key={"excess_" + index} className="quote-detail-row">
                    <span>{excess.description}</span>
                    <span className="detail-value">&pound;{excess.amount}</span>
                </div>)
            })}

            <p className="detail-header">Important documents</p>
            <p>Limitations and Exclusions may apply. Please read the document below for details</p>

            {documentExists(`documents/policysummary${props.quote.schemeTableId}.pdf`) &&
                <a type="button"
                    className="quote-document"
                    href={require(`../../documents/policysummary${props.quote.schemeTableId}.pdf`)}
                    target="_blank"
                    rel="noreferrer">
                    Policy Summary <FontAwesomeIcon icon={faFileLines} />
                </a>
            }

            {documentExists(`documents/policywording${props.quote.schemeTableId}.pdf`) &&
                <a type="button"
                    className="quote-document"
                    href={require(`../../documents/policywording${props.quote.schemeTableId}.pdf`)}
                    target="_blank"
                    rel="noreferrer">
                    Policy Wording <FontAwesomeIcon icon={faFileLines} />
                </a>
            }

            <a type="button"
                className="quote-document"
                href={`https://www.${config.baseLinkUrl}/terms-of-business`}
                target="_blank"
                rel="noreferrer">
                Terms of Business <FontAwesomeIcon icon={faFileLines} />
            </a>

            <span className="quote-document" onClick={() => togglePopup()}>Limitations & Exclusions <FontAwesomeIcon icon={faFileLines} /></span>

            {isPopupOpen && <Popup
                content={<>
                    <h1>Limitations & Exclusions</h1>
                    {props.quote.breakdown.limitations != null && props.quote.breakdown.limitations.length > 0 &&
                        props.quote.quote.endorsementsField.map((endorsement: any, index: number) => {

                            return (<div key={"endorsement_" + index} className="endorsement">
                                <p className="endorsement-title">{endorsement.code}-{endorsement.title}</p>
                                <p>{endorsement.fullWordingField}</p>
                            </div>)
                        })}
                    {(props.quote.breakdown.limitations == null || props.quote.breakdown.limitations.length === 0) &&
                        <p>No Limitations & Exclusions to display</p>}
                </>}
                handleClose={togglePopup}
            />}

            <p className="detail-header">Premium breakdown</p>
            {props.quote.breakdown.cover.map((premCover: any, index: number) => {

                return (<div key={"sums_" + premCover.coverText + "_" + index} className="quote-detail-row">
                    <span>{premCover.coverText}</span>
                    <span className="detail-value">{premCover.premium}</span>
                </div>)
            })}

            <p className="detail-header">How you pay</p>
            {props.payAnnual &&
                <div className="quote-detail-row">
                    <span>Annual Premium <small>(including IPT at the appropriate rate)</small></span>
                    <span className="detail-value">&pound;{parseFloat(props.quote.summaryPremium.toString()).toFixed(2)}</span>
                </div>
            }
            {!props.payAnnual &&
                <>
                    <div className="quote-detail-row">
                        <span>Annual Premium <small>(including IPT at the appropriate rate)</small></span>
                    <span className="detail-value">&pound;{parseFloat(props.quote.summaryPremium.toString()).toFixed(2)}</span>
                    </div>
                    <div className="quote-detail-row">
                        <span>Deposit required</span>
                    <span className="detail-value">&pound;{parseFloat(props.quote.paymentPlans[0].deposit.toString()).toFixed(2)}</span>
                    </div>
                    <div className="quote-detail-row">
                        <span>Charge for credit (
                        {props.quote.paymentPlans[0].serviceChargePercentage}% on remaining balance)</span>
                        <span className="detail-value">&pound;{props.quote.paymentPlans[0].serviceCharge}</span>
                    </div>
                    <div className="quote-detail-row">
                    <span>First instalment payment</span>
                    <span className="detail-value">&pound;{addInterestToPrice(props.quote.paymentPlans[0].instalments[0].capital, props.quote.paymentPlans[0].instalments[0].interest)}</span>
                    </div>
                    <div className="quote-detail-row">
                    <span>{props.quote.paymentPlans[0].noInstalments - 1} instalment payments</span>
                    <span className="detail-value">&pound;{addInterestToPrice(props.quote.paymentPlans[0].instalments[1].capital, props.quote.paymentPlans[0].instalments[1].interest)}</span>
                    </div>
                    <div className="quote-detail-row">
                        <span>Total Payable</span>
                    <span className="detail-value">&pound;{parseFloat(props.quote.premiumInCapr.toString()).toFixed(2)}</span>
                    </div>
                </>
            }
        </div>
    )
}